<template>
  <ul class="ContentProseUl">
    <slot />
  </ul>
</template>

<style lang="scss">
.ContentProseUl {
  padding-left: var(--spacing-6x);
}
</style>
